
import React from 'react';
import { InfoIcon } from 'lucide-react';

const InfoBanner: React.FC = () => {
  return (
    <div className="bg-blue-50 dark:bg-blue-950/30 p-4 rounded-md flex gap-2 mb-4">
      <InfoIcon className="text-blue-500 dark:text-blue-400 mt-1 flex-shrink-0" size={18} />
      <div className="text-sm text-blue-700 dark:text-blue-300">
        <p className="font-medium mb-1">Auto-updating statistics</p>
        <p>When you link a poll to an insight card, the card's statistics will automatically update based on the poll results. This helps keep your insights accurate and up-to-date.</p>
      </div>
    </div>
  );
};

export default InfoBanner;
